import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "位图转换选项"
    }}>{`位图转换选项`}</h1>
    <p>{`将图像转换为位图模式的选项，使用 `}<a parentName="p" {...{
        "href": "/uxp-photoshop-zh-cn/ps_reference/classes/document/#changemode"
      }}>{`Document.changeMode`}</a>{` 与 `}<inlineCode parentName="p">{`ChangeMode.BITMAP`}</inlineCode>{`.`}</p>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`名称`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`类型`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`访问`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`默认`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`范围`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`最低版本`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`描述`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`angle`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`R W`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-180...180`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`23.0`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`确定各个点的方向的角度（以度为单位）。见下面的形状属性。只有当方法属性被设置为 `}{`\``}{`BitmapConversionType.HALFTONESCREEN`}{`\``}{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`frequency`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`R W`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1.0..999.99`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`23.0`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`要使用的点的数量（每英寸）。只有当方法属性被设置为 `}{`\``}{`BitmapConversionType.HALFTONESCREEN`}{`\``}{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`method`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/uxp-photoshop-zh-cn/ps_reference/modules/constants/#bitmapconversiontype"
            }}><em parentName="a">{`BitmapConversionType`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`R W`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`DIFFUSIONDITHER`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`23.0`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`转换方法。`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`patternName`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`R W`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`23.0`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`要使用的模式的名称。只有当方法属性被设置为 BitmapConversionType.CUSTOMPATTERN.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`resolution`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`R W`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`72`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`23.0`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`输出分辨率（以每英寸像素为单位）。`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`shape`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/uxp-photoshop-zh-cn/ps_reference/modules/constants/#bitmaphalftonetype"
            }}><em parentName="a">{`BitmapHalfToneType`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`R W`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`23.0`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`点的形状。只有当方法属性被设置为 BitmapConversionType.HALFTONESCREEN.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`typename`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`R`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`23.0`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`被引用对象的类名: `}<em parentName="td">{`"`}{`BitmapConversionOptions`}{`"`}</em>{`.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      